export default {"src":"/_next/static/media/star_icon.ff0ea8d5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};